import React from 'react';
import { Mouvement } from '@mairistem/comptabilite';
import TypologiesPesComponent from '../../../components/Mouvement/Panel/TypologiesPesComponent';
import CODE_PANEL from '../../../constants/mouvements/codePanel';
import MouvementPanel from './MouvementPanel';

class TypologiePesPanel extends MouvementPanel {
  constructor(isMandatory = false) {
    super(isMandatory);
    this.code = CODE_PANEL.TYPOLOGIE_PES;
    this.icon = { name: 'crosshairs' };
  }

  getLibelle = () => 'Typologie PES';

  isEmpty = (data: Mouvement) => !data?.naturePiece && !data?.typePiece;

  getComponent = function getComponent(
    data: any,
    onChange: any,
    handlePin: any,
    sens: string,
    ...rest: any
  ): React.ReactElement {
    return (
      <TypologiesPesComponent
        data={data}
        handlePin={handlePin}
        onChange={onChange}
        panel={this}
        sens={sens}
        {...rest}
      />
    );
  };
}

export default TypologiePesPanel;
